<template>
    <!--基础信息-->
    <div class="temp-content-info">
        <div class="temp-content-title">
            基础信息
        </div>
        <div class="item-wrap">
            <div class="item-name">营地名称</div>
            <div class="item-content">
                {{ campData.name || '--' }}
            </div>     
        </div>

        <div class="item-wrap">
            <div class="detail-item">
                <div class="item-name">营地ID</div>
                <div class="item-content">
                    {{ campData.id || '--' }}
                </div>
            </div>

            <div class="detail-item">
                <div class="item-name">状态</div>
                <div class="item-content">
                    {{ campData.is_active ? '已启用' : '已停用'  }}
                </div>
            </div>

            <div class="detail-item">
                <div class="item-name">价格</div>
                <div class="item-content">
                    {{ campData.price || '--' }}
                </div>
                <div class="item-desc"  @click="openPriceDescDialog">价格说明</div>

                <t-dialog
                    v-model:visible="priceDescDialogVisible"
                    header="价格说明"
                    :body="campData.price_desc || '暂无价格说明'"
                    :on-close="closePriceDescDialog"
                    :cancel-btn="null"
                    @confirm="closePriceDescDialog"
                />
            </div>
          
        </div>

        <div class="item-wrap">
            <div class="detail-item">
                <div class="item-name">评分</div>
                <div class="item-content">
                    {{ campRate || '--' }}
                </div>
            </div>


            <div class="detail-item">
                <div class="item-name">实地认证</div>
                <div class="item-content">
                    {{ campData.is_on_site ? '是' : '否' }}
                </div>
            </div>

            

            <div class="detail-item">
                <div class="item-name">营业时间</div>
                <div class="item-content">
                    {{ campData.start_time }} - {{ campData.end_time }}
                </div>
            </div>
        </div>

        <div class="item-wrap">

            <div class="detail-item">
                <div class="item-name">联系电话</div>
                <div class="item-content">
                    {{ campData.phone || '--' }}
                </div>
            </div>
        </div>

        <div class="item-wrap">
            <div class="item-name">营地类型</div>
            <div class="item-content">
                {{ campType || '--' }}
            </div>     
        </div>

        <div class="item-wrap">
            <div class="item-name">营地标签</div>
            <div class="item-content">
                {{campTag || '--' }}
            </div>     
        </div>

        <div class="item-wrap">
            <div class="item-name">营地位置</div>
            <div class="item-content">
                {{ campData.camp_adress || '--' }}
            </div>     
        </div>

        <div class="item-wrap">
            <div class="detail-item">
                <div class="item-name">修改时间</div>
                <div class="item-content">
                    {{ formatTime(campData.update_time) || '--' }}
                </div>
            </div>

            <div class="detail-item">
                <div class="item-name">修改人</div>
                <div class="item-content">
                    {{ campData.update_by || '--' }}
                </div>
            </div>

            <div class="detail-item">
                <div class="item-name">创建时间</div>
                <div class="item-content">
                    {{ formatTime(campData.create_time) || '--' }}
                </div>
            </div>
        </div>

    </div>

    <!--营地图片-->
    <div class="temp-content-info">
        <div class="temp-content-title">
            营地图片
        </div>
        <div class="item-wrap">
            <div class="item-name">营地图片</div>
            <div class="image-area">
                <t-image
                    class="camp-image"
                     v-for="(image, index) in campData.image"
                    :key="index"
                    :src="image.image_url"
                    fit="contain"
                    :overlay-content="imageMask"
                    overlay-trigger="hover"
                    @click="openImageViewer(index)"
                    
                />
            </div>
        </div>
         
    </div>

    <!--营地设施-->
    <div class="temp-content-info">
        <div class="temp-content-title">
            营地设施
        </div>

        <t-table
            :data="facilityData" 
            :columns="campFacility"
            tableLayout="fixed"
            :show-header="true"
            cell-empty-content="--"
            row-key="index"
            resizable
            lazy-load
            size="large"
            bordered
            hover
      >
      </t-table>

    </div>

    <t-image-viewer
        v-if="showImageViewer"
        v-model:visible="showImageViewer"
        :images="imageData"
        :defaultIndex="currentImageIndex"
        :show-indicators="true"
    /> 

</template>


<script setup lang="jsx">
    import { ref, computed, onMounted } from 'vue';
    import { useRoute } from 'vue-router';
    import { BrowseIcon } from 'tdesign-icons-vue-next';
    import campAPI from '../../../api/camp-api';
    import { formatTime } from '../../../utils/datetime';

    /**
     * 默认定义数据
     */

    const route = useRoute();
    const campData = ref({});
    //价格说明弹窗状态
    const priceDescDialogVisible = ref(false);

    /**
     * 营地评分展示
     */
    const campRate = computed(() => {
        if (!campData.value) return '--';
        const rate = campData.value.rate || '--';
        const envRate = campData.value.env_rate || '--';
        const facilityRate = campData.value.facility_rate || '--';
        const experienceRate = campData.value.experience_rate || '--';
        return `${rate}（环境${envRate}，设施${facilityRate}，体验${experienceRate}）`;
    });

    /**
     * 营地类型展示
     */
    const campType = computed(() => {
        if (!campData.value.camp_type || campData.value.camp_type.length === 0) {
            return '--';
        }
        return campData.value.camp_type.map(type => type.name).join(', ');
    });

    /**
     * 营地标签展示
     */
    const campTag = computed(() => {
        if (!campData.value.tags || campData.value.tags.length === 0) {
            return '--';
        }
        // 处理新的标签数据结构
        return campData.value.tags.map(tag => tag.name).join(', ');
    });

    /**
     * 营地设施表列定义
     */
    const campFacility = ref([
        { colKey: 'order', title: '序号', width:80, },
        { colKey: 'facilityName', title: '设施名称' },
        { colKey: 'facilityContent', title: '设施内容' },
        { colKey: 'facilityDesc', title: '说明'},
        { colKey: 'facilityGroup', title: '分组'},
    ]);
    
    const facilityData = computed(() => {
        if (!campData.value.facility) return [];
        
        return campData.value.facility.map((item, index) => ({
            order: index + 1,
            facilityName: item.facility_name,
            facilityContent: item.facility_content,
            facilityDesc: item.facility_desc,
            facilityGroup: item.facility_group
        }));
    });


    const imageData = computed(() => campData.value.image ? campData.value.image.map(img => img.image_url) : []);

    onMounted(async () => {
        try {
            const id = route.params.id;
            const response = await campAPI.getCampDetail(id);
            campData.value = response;
        } catch (error) {
            console.error('Failed to fetch camp details:', error);
        }
    });


    /**
     * 查看/关闭价格说明弹窗
     */
    const openPriceDescDialog = () => {
        priceDescDialogVisible.value = true;
    };

    const closePriceDescDialog = () => {
        priceDescDialogVisible.value = false;
    };

    /**
     * 预览图片
     */
    const showImageViewer = ref(false);
    const currentImageIndex = ref(0); 
    const openImageViewer = (index) => {
        currentImageIndex.value = index;
        showImageViewer.value = true; 
    }; 

    const imageMask = () => (
        <div
            style={{
                background: 'rgba(0,0,0,.6)',
                color: '#fff',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
            }}
        >
            <div><BrowseIcon size="1.4em" /> 预览</div>
        </div>
    );
</script>

<style scoped>
    @import "./camp-detail.css";
    @import "../../../components/style/style-detail.css";
    @import "../../../components/style/style-table.css";
</style>
  